import { render } from "./Setting.vue?vue&type=template&id=aa59f8c2"
import script from "./Setting.vue?vue&type=script&lang=js"
export * from "./Setting.vue?vue&type=script&lang=js"

import exportComponent from "F:\\TheDreamMusic\\aimusicxml\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__